export const rules ={
    name: [
    { required: true, message: "请输入名称", trigger: "blur" },
  ],
  model_no: [
    { required: true, message: "请输入型号", trigger: "blur" },
  ],
  type: [
    { required: true, message: "类型", trigger: "change" },
  ],
  brand_id: [
    { required: true, message: "品牌", trigger: "change" },
  ]
 
}